import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { FindQuery } from '../../../../generated/graphql.generated';
import { ActionSource } from '../../../state/action-sources';

export const JobTimelineActions = createActionGroup({
	source: ActionSource.JOB_TIMELINE_AVAILABILITY,
	events: {
		'Header Clicked': emptyProps(),
		'Moving Date Selected': props<{
			movingDate: Date,
		}>(),
		'Time Slot Selected': props<{
			timeSlot: string,
		}>(),
		'Time Slot Loaded': props<{
			timeSlot: string,
		}>(),
		'Find Availability Success': props<{
			 windows: FindQuery['find']['windows'];
			 timezone: string;
		}>(),
		'Find Availability Error': props<{ error: Error }>(),
	},
});
